import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../App';
import { SpinnerGap } from '@phosphor-icons/react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login, isAuthenticated } = useAuth();
  const tokenProcessed = useRef(false);

  useEffect(() => {
    if (tokenProcessed.current) return;
    const token = searchParams.get('token');

    if (token) {
      tokenProcessed.current = true;
      login(token);
    } else {
      const error = searchParams.get('error');
      if (error) {
        console.error('Auth error:', error);
      }
      navigate('/login', { replace: true });
    }
  }, [searchParams, login, navigate]);

  // Navigate only after user is loaded
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-[#F9F8F5] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <SpinnerGap className="w-12 h-12 animate-spin text-[#A94438] mx-auto" />
        <p className="mt-4 text-[#7A7873]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
